import clsx from 'clsx'

import { WEB_CONSEST_LINK, WEB_OFFER_LINK_SC_NEW, WEB_POLICY_LINK } from '@/shared/lib/utils/constants/pdfDocs'
import { Button } from '@/shared/ui'
import { Text } from '@/shared/ui'

import { SERVICE_GTM_IDS, SERVICE_YA_METRICS_IDS } from '../../../data/analitycs'

import cl from './form-submit.module.scss'

type FormSubmitProps = {
	isLoading?: boolean
	disabled?: boolean
}

export const FormSubmit = (props: FormSubmitProps) => {
	const { isLoading, disabled = false } = props

	return (
		<div className={cl.formSubmit}>
			<Button
				className={clsx(SERVICE_GTM_IDS.serviceFormSubmitButton, SERVICE_YA_METRICS_IDS.serviceFormSubmitButton)}
				size="L"
				fullWidth
				type="submit"
				isLoading={isLoading}
				disabled={disabled}>
				Отправить заявку
			</Button>
			<Text>
				Нажимая кнопку, я&nbsp;подтверждаю свое ознакомление и&nbsp;согласие с&nbsp;
				<a href={WEB_OFFER_LINK_SC_NEW} target="_blank">
					Офертой
				</a>
				,{' '}
				<a href={WEB_POLICY_LINK} target="_blank">
					Политикой Конфиденциальности
				</a>
				,
				<a href={WEB_CONSEST_LINK} target="_blank">
					{' '}
					Согласием на&nbsp;обработку персональных данных
				</a>
				. Я&nbsp;достиг(ла) 18-летнего возраста.
			</Text>
		</div>
	)
}
